const API = process.env.REACT_APP_BACKEND_URL;

export const track = (page) => {
  try {
    fetch(`${API}/api/track`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* tracking must never break the UI */
  }
};
